module.exports = __webpack_public_path__ + "img/task_add_icon.6a2f4d1b.svg";